module.exports = __webpack_public_path__ + "static/img/statusCorrectDusty.d51dcdfb.gif";